import React, { useState } from 'react';
import { CgClose } from 'react-icons/cg';

import { Container, Overlay } from './styles';

import NavbarLink from 'component/landing/navbar-link';
import useLockScroll from 'hooks/useLockScroll';
import useKeyPress from 'hooks/useKeyPress';
import useIsMobile from 'hooks/useIsMobile';

function SuperSubMenu({ text, children }) {
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const { handleLockScroll } = useLockScroll();
  const isMobile = useIsMobile();

  useKeyPress('Escape', () => {
    setIsSubmenuOpen(false);
  });

  const handleOpenSubmenu = () => {
    if (!children) return;

    setIsSubmenuOpen(prev => {
      const isOpen = !prev;
      handleLockScroll(isOpen && !isMobile);

      return isOpen;
    });
  };

  const toggler =
    typeof text === 'string' ? (
      <NavbarLink hasSubMenu>{text}</NavbarLink>
    ) : (
      text
    );

  return (
    <div>
      <div onClick={handleOpenSubmenu}>{toggler}</div>
      {isSubmenuOpen && (
        <>
          <Overlay onClick={handleOpenSubmenu} />
          <Container>
            <div className="close-button" onClick={handleOpenSubmenu}>
              <CgClose />
            </div>
            <div className="menu-container">
              <div className="content" onClick={handleOpenSubmenu}>
                {children}
              </div>
            </div>
          </Container>
        </>
      )}
    </div>
  );
}

export default SuperSubMenu;
